import { raundColors } from '@/theme/colors'
import { Radio as MantineRadio } from '@mantine/core'
import type React from 'react'
import styles from './Radio.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type RadioProps = {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (value: string) => void
  disabled?: boolean
  label?: string
  value?: string
  name?: string
  style?: React.CSSProperties
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
export const Radio = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  label,
  value,
  name,
  style,
  className,
}: RadioProps) => {
  return (
    <MantineRadio
      checked={checked}
      defaultChecked={defaultChecked}
      onChange={(e) => onChange?.(e.currentTarget.value)}
      disabled={disabled}
      label={label}
      value={value}
      name={name}
      style={
        {
          // Mantine v8: --radio-size でinner/radio/iconを一括サイズ指定
          '--radio-size': '24px',
          // checked 時は Radio.module.css で --mantine-color-primary-5 を適用するため
          // --radio-color は上書きせず、アイコン色のみ白に設定する
          '--radio-icon-color': raundColors.white,
          ...style,
        } as React.CSSProperties
      }
      className={className}
      classNames={{
        radio: styles.radio,
      }}
    />
  )
}
